import { Injectable } from '@angular/core';
import { getLegalEntity, State } from '@cemex/cmx-client-layout';
import { timeIntervalConfig } from '../configs/time-interval-config';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';
import { ITimeInterval } from '../models/time-interval.interface';
import { getBusinessLine } from '@ordersnproducts/modules/order-builder/reducers';
import {
  selectActiveShipmentLocationEntityAndProductTypeAndShippingCondition,
} from '@ordersnproducts/modules/multiple-order-online/redux/selectors/orders-catalogs.selector';

@Injectable()
export class TimeIntervalService {
  constructor(private store: Store<State>) {}
  public defaultConfig = timeIntervalConfig.find(config => config.countryCode === 'US');
  public countryConfig: ITimeInterval;

  public getTimeInterval(): Observable<ITimeInterval> {
    return combineLatest([
      this.store.select(selectActiveShipmentLocationEntityAndProductTypeAndShippingCondition),
      this.store.select(getBusinessLine).pipe(take(1)),
      this.store.select(getLegalEntity),
    ]).pipe(
      map(([{ activeProductType }, businessLine, legalEntity]) => {
        let businessLineId;
        if (!!businessLine && !!businessLine.selected) {
          businessLineId = businessLine.selected.productTypeId;
        } else {
          businessLineId = activeProductType.productTypeId;
        }

        let interval;
        // ReadyMix id
        if (businessLineId === 6) {
          const configExists = timeIntervalConfig.find((config) => config.countryCode === legalEntity.countryCode);
          interval = configExists ? configExists.timeIntervalReadyMix : this.defaultConfig.timeIntervalDefault;
        } else {
          interval = this.defaultConfig.timeIntervalDefault;
        }

        return interval;
      }),
    );
  }
}
